import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '/@/components/dialog';
import { _ } from '/@/locale';
import { getAppInstance } from '/@/store/session/selectors';
import styles from './styles.module.css';

@connect((state) => ({ appInstance: getAppInstance(state) }))
@autobind
export default class TermsAndConditions extends Component {
    static propTypes = {
        visible: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
        onAccept: PropTypes.func.isRequired,
    };

    render() {
        return (
            <Dialog
                className={styles.popup}
                visible={this.props.visible}
                title={_('Términos y condiciones')}
                message={_(this.props.appInstance.termsAndConditions)}
                onClose={this.props.onClose}
            />
        );
    }
}
